import ModalSignUp from "./ModalSignUp";
export default ModalSignUp;